module.exports = __webpack_public_path__ + "img/keepGrain-m.dab1bf0f.png";